import { NotFoundPage } from '~/components/common';
import { AuthLayout } from '~/layouts';
import {
  ForgotPasswordCommonPage,
  LoginCommonPage,
  ResetPasswordCommonPage,
  VerifyCodeCommonPage,
} from '~/pages/public';
import { IRouteModel } from '~/utils/interface/base';

export const authRoute = {
  base: '/auth',
  forgotPassword: '/forgot-password',
  verifyCode: '/verify-code',
  createNewPassword: '/create-new-password',
};

export const authRouteAbsolute = {
  login: `${authRoute.base}`,
  forgotPassword: `${authRoute.base}${authRoute.forgotPassword}`,
  verifyCode: `${authRoute.base}${authRoute.verifyCode}`,
  createNewPassword: `${authRoute.base}${authRoute.createNewPassword}`,
};

export const authRoutes: IRouteModel[] = [
  {
    path: authRoute.base,
    component: AuthLayout,
    children: [
      {
        index: true,
        path: '',
        component: LoginCommonPage,
      },
      {
        path: authRouteAbsolute.forgotPassword,
        component: ForgotPasswordCommonPage,
      },
      {
        path: authRouteAbsolute.verifyCode,
        component: VerifyCodeCommonPage,
      },
      {
        path: authRouteAbsolute.createNewPassword,
        component: ResetPasswordCommonPage,
      },
    ],
  },
];
